/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkturough_Plant_Forest_TitleInputs */

const en_walkturough_plant_forest_title = /** @type {(inputs: Walkturough_Plant_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each tree adds up, watch it grow to your own Forest.`)
};

const ar_walkturough_plant_forest_title = /** @type {(inputs: Walkturough_Plant_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل شجرة تُحدث فرقًا، شاهدها تنمو لتصبح غابتك الخاصة.`)
};

const de_walkturough_plant_forest_title = /** @type {(inputs: Walkturough_Plant_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Baum summiert sich, sieh zu, wie er zu deinem eigenen Wald wächst.`)
};

const es_walkturough_plant_forest_title = /** @type {(inputs: Walkturough_Plant_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada árbol suma, mira cómo crece tu propio bosque.`)
};

const fr_walkturough_plant_forest_title = /** @type {(inputs: Walkturough_Plant_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque arbre s’additionne, regardez-le grandir jusqu’à devenir votre propre forêt.`)
};

const it_walkturough_plant_forest_title = /** @type {(inputs: Walkturough_Plant_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni albero conta, guardalo crescere e diventare la tua Foresta.`)
};

const ja_walkturough_plant_forest_title = /** @type {(inputs: Walkturough_Plant_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`木が1本ずつ増えて、やがて自分だけの森になります`)
};

const ko_walkturough_plant_forest_title = /** @type {(inputs: Walkturough_Plant_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나무를 하나씩 심어 나만의 숲으로 성장하는 모습을 지켜 볼 수 있어요.`)
};

const pt_br_walkturough_plant_forest_title = /** @type {(inputs: Walkturough_Plant_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada árvore se soma, observe-a crescer e formar sua própria floresta.`)
};

const ru_walkturough_plant_forest_title = /** @type {(inputs: Walkturough_Plant_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каждое дерево имеет значение, наблюдайте, как разрастается ваш лес.`)
};

const th_walkturough_plant_forest_title = /** @type {(inputs: Walkturough_Plant_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้แต่ละต้น คือก้าวเล็ก ๆ สู่ป่าใหญ่ของคุณ`)
};

const tr_walkturough_plant_forest_title = /** @type {(inputs: Walkturough_Plant_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her ağacın birleşip bir ormana dönüşmesini izle.`)
};

const zh_cn_walkturough_plant_forest_title = /** @type {(inputs: Walkturough_Plant_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`随着不断累积，将成为你独一无二的专注森林。`)
};

const zh_tw_walkturough_plant_forest_title = /** @type {(inputs: Walkturough_Plant_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隨著不斷累積，將成為你獨一無二的專注森林。`)
};

/**
* | output |
* | --- |
* | "Each tree adds up, watch it grow to your own Forest." |
*
* @param {Walkturough_Plant_Forest_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const walkturough_plant_forest_title = /** @type {((inputs?: Walkturough_Plant_Forest_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkturough_Plant_Forest_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_walkturough_plant_forest_title(inputs)
	if (locale === "ar") return ar_walkturough_plant_forest_title(inputs)
	if (locale === "de") return de_walkturough_plant_forest_title(inputs)
	if (locale === "es") return es_walkturough_plant_forest_title(inputs)
	if (locale === "fr") return fr_walkturough_plant_forest_title(inputs)
	if (locale === "it") return it_walkturough_plant_forest_title(inputs)
	if (locale === "ja") return ja_walkturough_plant_forest_title(inputs)
	if (locale === "ko") return ko_walkturough_plant_forest_title(inputs)
	if (locale === "pt_br") return pt_br_walkturough_plant_forest_title(inputs)
	if (locale === "ru") return ru_walkturough_plant_forest_title(inputs)
	if (locale === "th") return th_walkturough_plant_forest_title(inputs)
	if (locale === "tr") return tr_walkturough_plant_forest_title(inputs)
	if (locale === "zh_cn") return zh_cn_walkturough_plant_forest_title(inputs)
	return zh_tw_walkturough_plant_forest_title(inputs)
});